export const IMAGE_LOGO_TEACHER = "IMAGE_LOGO_TEACHER";
export const IMAGE_LOGO_STUDENT = "IMAGE_LOGO_STUDENT";
export const IMAGE_PROFILE_HEADERS = "IMAGE_PROFILE_HEADERS";
